import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Power_Type_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Lens_Details_Modal from "../lens_details_modal/Lens_Details_Modal";
import { useDispatch, useSelector } from "react-redux";
import { getAllLensType } from "../../../../features/master/masterSlice";

const Power_Type_Modal = ({ product, variant, product_id, ...props }) => {
  const data = [
    {
      img: "/assets/images/popular-product/1.png",
      label: "With Power",
      descn: "Positive, Negative or Cylindrcal",
    },
    {
      img: "/assets/images/popular-product/2.png",
      label: "Zero Power",
      descn: "Positive, Negative or Cylindrcal",
    },
    {
      img: "/assets/images/popular-product/3.png",
      label: "Reading Power",
      descn: "Positive, Negative or Cylindrcal",
    },
    {
      img: "/assets/images/popular-product/2.png",
      label: "Frame Only",
      descn: "Positive, Negative or Cylindrcal",
    },
    {
      img: "/assets/images/popular-product/1.png",
      label: "With Power",
      descn: "Positive, Negative or Cylindrcal",
    },
  ];

  const [showSecondModal, setShowSecondModal] = useState(false);
  const [lensTypeId, setLensTypeId] = useState(false);
  const dispatch = useDispatch();
  const lensType = useSelector((state) => state.master.lens_type);
  useEffect(() => {
    dispatch(getAllLensType());
  }, []);
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Power_Type_Modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="modal_content_div">
            <p className="title_text">Select Your Power Type</p>

            <div className="all_cards_holder">
              {lensType?.map((item) => {
                return (
                  <div
                    className="row_holder"
                    onClick={() => {
                      props?.onHide();
                      setShowSecondModal(true);
                      setLensTypeId(item?.id);
                    }}
                  >
                    <div className="left_img_div">
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + item?.image}
                        className="img_class"
                      />
                    </div>
                    <div className="text_holder">
                      <div className="left_text_div">
                        <p className="label_text">{item?.name}</p>
                        {/* <p className="descn_text">{item?.descn}</p> */}
                      </div>
                      <div className="icon_holder">
                        <FontAwesomeIcon icon={faAngleRight} className="icon" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Lens_Details_Modal
        product={product}
        variant={variant}
        product_id={product_id}
        lensTypeId={lensTypeId}
        show={showSecondModal}
        onHide={() => {
          setShowSecondModal(false);
        }}
      />
    </>
  );
};

export default Power_Type_Modal;
